import {
  Send,
} from "lucide-react";
import type {
  useApprovalsWorkspace,
} from "./useApprovalsWorkspace";

export function ReturnedApprovalQueue({ model }: { model: ReturnType<typeof useApprovalsWorkspace>; }) {
  const {
    initialRequestNo,
    returnedDecisions,
    forwardingReturnId,
    showReturnedQueue,
    orderedReturnedDecisions,
    forwardReturnedDecision,
  } = model;
  return (<>
    {showReturnedQueue && returnedDecisions.length > 0 ? (
      <section
        className="manager-return-queue"
        aria-label="Reddedilen dosyalar"
      >
        <header>
          <div>
            <span className="section-kicker">
              Genel Müdürden dönen dosyalar
            </span>
            <h2>Uzman yönlendirmesi bekleyenler</h2>
          </div>
          <span>{returnedDecisions.length} dosya</span>
        </header>
        {orderedReturnedDecisions.map((returnRecord) => (
          <article
            key={returnRecord.id}
            className={
              returnRecord.requestNo === initialRequestNo
                ? "is-focused"
                : undefined
            }
          >
            <div>
              <small>{returnRecord.requestNo}</small>
              <strong>{returnRecord.title}</strong>
              <p>{returnRecord.instruction}</p>
              <span>
                {returnRecord.requestedBy} ·{" "}
                {new Date(returnRecord.requestedAt).toLocaleString("tr-TR")}
              </span>
            </div>
            <div className="manager-return-fields">
              {returnRecord.fields.map((field) => (
                <span key={field}>{field}</span>
              ))}
            </div>
            <button
              type="button"
              className="warning-button"
              disabled={forwardingReturnId === returnRecord.id}
              onClick={() => void forwardReturnedDecision(returnRecord)}
            >
              <Send size={15} />
              {forwardingReturnId === returnRecord.id
                ? "Yönlendiriliyor…"
                : "Uzmana yönlendir"}
            </button>
          </article>
        ))}
      </section>
    ) : null}
  </>);
}
